function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M476.996,114.074l-34.133-102.4C440.541,4.701,434.016-0.002,426.667,0H51.2c-7.349-0.002-13.874,4.701-16.196,11.674 L0.87,114.074c-0.526,1.594-0.82,3.255-0.87,4.932c0,0.171,0,0.29,0,0.461v17.067c0.062,26.74,12.707,51.892,34.133,67.891 c0,0.137,0,0.239,0,0.375v221.867c0,28.277,22.923,51.2,51.2,51.2h307.2c28.277,0,51.2-22.923,51.2-51.2V204.8 c0-0.137,0-0.239,0-0.375c21.426-15.999,34.072-41.151,34.133-67.891v-17.067c0-0.171,0-0.29,0-0.461 C477.816,117.328,477.523,115.667,476.996,114.074z M358.4,34.133h55.962l22.767,68.267H358.4V34.133z M256,34.133h68.267V102.4 H256V34.133z M153.6,34.133h68.267V102.4H153.6V34.133z M63.505,34.133h55.962V102.4H40.738L63.505,34.133z M273.067,443.733 H204.8V307.2h68.267V443.733z M409.6,426.667c0,9.426-7.641,17.067-17.067,17.067H307.2v-153.6 c0-9.426-7.641-17.067-17.067-17.067h-102.4c-9.426,0-17.067,7.641-17.067,17.067v153.6H85.333 c-9.426,0-17.067-7.641-17.067-17.067V220.16c23.951,4.917,48.857-0.799,68.267-15.667c30.466,22.376,71.934,22.376,102.4,0 c30.466,22.376,71.934,22.376,102.4,0c19.41,14.869,44.316,20.584,68.267,15.667V426.667z M392.533,187.733 c-14.759-0.009-28.774-6.483-38.349-17.715c-6.202-7.097-16.984-7.823-24.081-1.621c-0.576,0.503-1.118,1.045-1.621,1.621 c-18.977,21.18-51.529,22.965-72.709,3.989c-1.401-1.256-2.733-2.587-3.989-3.989c-6.679-7.097-17.847-7.437-24.945-0.757 c-0.26,0.245-0.513,0.497-0.757,0.757c-18.976,21.18-51.529,22.965-72.709,3.989c-1.402-1.256-2.733-2.587-3.989-3.989 c-6.679-7.097-17.848-7.437-24.945-0.757c-0.26,0.245-0.513,0.497-0.757,0.757c-9.575,11.232-23.589,17.706-38.349,17.715 c-28.277,0-51.2-22.923-51.2-51.2h409.6C443.733,164.81,420.81,187.733,392.533,187.733z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgShopIcon = function SvgShopIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477.867 477.867",
    style: {
      enableBackground: "new 0 0 477.867 477.867"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShopIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shop-icon.c47891d2.svg";
export { ForwardRef as ReactComponent };